import React from 'react';

import { useCustomDashboardTiles } from './CustomWidgets.hooks';

import { CustomTile } from './CustomWidgets.types';
import { showCustomTile } from './CustomWidgets.utils';
import { CustomWidget } from '../CustomWidget/CustomWidget';
import { DashboardWidgetList } from '../DashboardSettings/DashboardSettings.types';
import { getCustomTileId, isHiddenCustomTile } from '../DashboardSettings/DashboardSettings.utils';

interface Props {
  hiddenWidgets?: DashboardWidgetList;
}

export const CustomWidgets = ({ hiddenWidgets }: Props) => {
  const { data, loading } = useCustomDashboardTiles();
  const customDashboardTiles = data?.customDashboardTiles;
  const dataAvailable = !loading && customDashboardTiles?.length;

  if (!dataAvailable || !customDashboardTiles) return null;

  return <>{getCustomTiles(customDashboardTiles, hiddenWidgets)}</>;
};

const getCustomTiles = (customTiles: CustomTile[], hiddenWidgets?: DashboardWidgetList) => {
  return customTiles.filter(showCustomTile).map((tile, index) => {
    const customTileId = getCustomTileId(tile);

    if (isHiddenCustomTile(hiddenWidgets, tile)) return null;

    return (
      <React.Fragment key={customTileId}>
        <CustomWidget customTile={tile} backgroundVariant={index % 4} />
      </React.Fragment>
    );
  });
};
